var _effectorFileName = "/builds/gmini/front-sm-api-sdk/src/EstimationApi/EstimationRepo/EstimationRepoFolder.ts";
import * as t from 'io-ts';
import { ApiCallService } from '@gmini/api-call-service';
import { createPredicate } from '../createPredicate';
import { Id } from '../../Id';
import { ApiDomain } from '../../domain';
import { Urn } from '../../Urn';
import { Estimation } from './Estimation';
export var EstimationRepoFolder;

(function (_EstimationRepoFolder) {
  var domain = ApiDomain.domain('EstimationRepoFolder', {
    name: "domain",
    sid: "-g30n0o"
  });
  var is = _EstimationRepoFolder.is = createPredicate('EstimationRepositoryFolder');
  var io = _EstimationRepoFolder.io = t.type({
    type: t.literal('EstimationRepositoryFolder'),
    id: Id,
    parentFolderId: t.union([t["null"], Id]),
    name: t.string,
    total: t.number,
    projectUrn: Urn
  });
  var Populated;

  (function (_Populated) {
    var is = _Populated.is = createPredicate('EstimationRepositoryFolderPopulated');
    var io = _Populated.io = t.recursion('EstimationRepositoryFolderPopulated', function () {
      return t.type({
        type: t.literal('EstimationRepositoryFolderPopulated'),
        id: Id,
        parentFolderId: t.union([t["null"], Id]),
        name: t.string,
        total: t.number,
        offset: t.number,
        children: t.readonlyArray(t.union([EstimationRepoFolder.io, Estimation.io])),
        projectUrn: Urn
      });
    });
    var fetch = _Populated.fetch = ApiCallService.create({
      name: 'fetch',
      parentDomain: domain,
      result: EstimationRepoFolder.Populated.io,
      getKey: ['id']
    });
    var fetchSilent = _Populated.fetchSilent = ApiCallService.create({
      name: 'fetchSilent',
      parentDomain: domain,
      result: EstimationRepoFolder.Populated.io,
      getKey: ['id']
    });
  })(Populated || (Populated = _EstimationRepoFolder.Populated || (_EstimationRepoFolder.Populated = {})));

  var create = _EstimationRepoFolder.create = ApiCallService.create({
    name: 'create',
    parentDomain: domain,
    result: EstimationRepoFolder.io,
    getKey: ['name', 'parentFolderId', 'projectUrn']
  });
  var rename = _EstimationRepoFolder.rename = ApiCallService.create({
    name: 'rename',
    parentDomain: domain,
    result: EstimationRepoFolder.io,
    getKey: ['id', 'parentFolderId', 'name']
  });
  var move = _EstimationRepoFolder.move = ApiCallService.create({
    name: 'move',
    parentDomain: domain,
    result: EstimationRepoFolder.io,
    getKey: ['id', 'parentFolderId']
  });
  var remove = _EstimationRepoFolder.remove = ApiCallService.create({
    name: 'remove',
    parentDomain: domain,
    result: EstimationRepoFolder.io,
    getKey: ['id']
  });
})(EstimationRepoFolder || (EstimationRepoFolder = {}));